import { jsx as _jsx } from "react/jsx-runtime";
import { useContext } from 'react';
import ToastContext from './ToastContext.js';
const ToastWrapper = ({ toast }) => {
    const ToastComponent = toast.component;
    return (_jsx(ToastComponent, { ...toast.props, className: "toast show position-relative", role: "alert", "aria-live": "assertive", "aria-atomic": "true" }));
};
const ToastContainer = () => {
    const { toasts } = useContext(ToastContext);
    return (_jsx("div", { className: "toast_container", style: {
            pointerEvents: 'none',
        }, children: toasts.length > 0 && toasts.map((toast) => _jsx(ToastWrapper, { toast: toast }, toast.id)) }));
};
export default ToastContainer;
//# sourceMappingURL=ToastContainer.js.map